export default __webpack_public_path__ + "static/media/logo.da7b6c13.svg";